import MigrationWarning from "../../../../contents/docs/migrate/_snippets/migration-warning.mdx";
import { CalloutBox } from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  MigrationWarning,
  CalloutBox,
  React
};